// @view/panels/document/Refine.panel.tsx
import React from "react";
import type { EmitOnAction } from "@ps-bridge/capabilitiesTypes";
import type { Section as SectionType } from "@ps-bridge/models/core/dataContracts";
import type { OptionTs } from "@ps-bridge/interop";
import * as Option from "@utils/Option";
import RefineContentView from "@view/document/RefineContent.view";
import RefineLoadingView from "@view/document/RefineLoading.view";

export type RefinePhase = "loading" | "content";

type RefinePanelProps = {
  phase: RefinePhase;
  mostRecentSection: OptionTs<SectionType>;
  onSubmit: EmitOnAction<string>;
};

const RefinePanel: React.FC<RefinePanelProps> = ({
  phase,
  mostRecentSection,
  onSubmit,
}) => {
  const contentView = Option.fold(
    mostRecentSection,
    () => <RefineLoadingView />,
    (section) => <RefineContentView section={section} onSubmit={onSubmit} />,
  );

  const render: Record<RefinePhase, React.ReactElement> = {
    loading: <RefineLoadingView />,
    content: contentView,
  } as const;

  return render[phase];
};

export default React.memo(RefinePanel, (prevProps, nextProps) => {
  return (
    prevProps.phase === nextProps.phase &&
    prevProps.mostRecentSection === nextProps.mostRecentSection
  );
});
